import loggerService from './loggerService';

const getAngularScope = async (ngControllerElement) => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    loggerService.error(error);
    return undefined;
  }

  return window.angular.element(ngControllerElement || document.body)?.scope();
};

export default getAngularScope;
